export default __webpack_public_path__ + "static/media/blue_ficsmas_ornament.70a899e3.png";